import ConsejoDirectivo from './ConsejoDirectivo';

export default ConsejoDirectivo;